module.exports = __webpack_public_path__ + "50edf349685a430779597a756cd97aaa.jpg";